<script setup>
const props = defineProps({
  class: {
    type: String
  }
})
</script>

<template>
  <svg :class="props.class" width="11" height="12" viewBox="0 0 11 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4.44531 11.2813V0.71875H6.54688V11.2813H4.44531ZM0.21875 7.04688V4.94531H10.7812V7.04688H0.21875Z" fill="currentColor"/>
  </svg>

</template>


<style>

</style>